import { Link } from "react-router-dom";
import { brand, nav, contact, social } from "../data/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gold/15 bg-charcoal">
      <div className="container-luxe grid gap-12 py-16 md:grid-cols-3 lg:gap-8">
        {/* Brand */}
        <div className="flex flex-col items-start gap-5">
          <img
            src={brand.logo}
            alt={brand.name}
            className="h-28 w-auto"
          />
          <p className="max-w-xs font-serif text-lg font-light leading-relaxed text-cream/70">
            {brand.tagline}. Certified diamonds, lab-grown brilliance and premium
            CZ jewellery.
          </p>
          {/* Only the official Instagram is shown. */}
          <a
            href={social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-cream/70 transition-all duration-300 hover:border-gold hover:text-gold"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
              <rect x="3" y="3" width="18" height="18" rx="5" />
              <circle cx="12" cy="12" r="4" />
              <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
            </svg>
          </a>
        </div>

        {/* Navigate */}
        <div>
          <h4 className="eyebrow mb-6">Explore</h4>
          <ul className="space-y-3">
            <li>
              <Link
                to="/"
                className="font-serif text-xl text-cream/80 transition-colors hover:text-gold"
              >
                Home
              </Link>
            </li>
            {nav.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="font-serif text-xl text-cream/80 transition-colors hover:text-gold"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Location — the only contact icon kept in the footer. */}
        <div>
          <h4 className="eyebrow mb-6">Location</h4>
          <a
            href={contact.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-start gap-3"
          >
            <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 text-gold transition-colors group-hover:border-gold">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0Z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </span>
            <address className="not-italic font-serif text-lg leading-relaxed text-cream/80 transition-colors group-hover:text-gold">
              {contact.addressLines.map((line) => (
                <span key={line} className="block">
                  {line}
                </span>
              ))}
            </address>
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-luxe flex flex-col items-center justify-between gap-3 py-6 text-center sm:flex-row sm:text-left">
          <p className="font-sans text-xs tracking-wide text-cream/40">
            © {year} {brand.legalName}. All rights reserved.
          </p>
          <p className="font-sans text-xs tracking-wide text-cream/40">
            {brand.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
